import { TREINSERIES_QUERY_KEY } from "@/entities/treinserie/constants.ts";
import { useApiClient } from "@/infrastructure/rest/apiClient";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useSyncLangsteRoutes() {
    const queryClient = useQueryClient();
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async () => {
            await apiClient.post(`/debug/langsteroutes`);
        },
        onSettled: async () => {
            await queryClient.invalidateQueries({ queryKey: [TREINSERIES_QUERY_KEY] });
        },
        onError: (error) => {
            console.error("Fout bij het synchroniseren van langste routes:", error);
        },
    });
}
